import { Component, ViewChild, Inject, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

import { TeamService } from 'src/app/shared/services/team.service';
import { TeamEditDetailsComponent } from '../team-edit/team-edit-details.component';

@Component({
  selector: 'app-team-clone',
  templateUrl: './team-clone.component.html',
})
export class TeamCloneComponent implements OnDestroy {
  private errorMessage: any;
  private subscriptions: Array<Subscription> = new Array<Subscription>();

  @ViewChild(TeamEditDetailsComponent)
  public editDetails: TeamEditDetailsComponent;
  public saving: boolean;

  public get teamId(): string {
    return this.data;
  }

  constructor(
    public dialogRef: MatDialogRef<TeamCloneComponent>,
    private teamService: TeamService,
    @Inject(MAT_DIALOG_DATA) private data: string
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public cloneTeam() {
    if (!this.saving) {
      if (this.editDetails.valid) {
        this.saving = true;
        this.subscriptions.push(
          this.teamService.cloneTeam(this.teamId, this.editDetails.outputTeamClone).subscribe(
            (team) => {
              if (team) {
                this.dialogRef.close(team.id);
              }
            },
            (error) => (this.errorMessage = <any>error)
          )
        );
      }
    }
  }
}
